import { render, staticRenderFns } from "./ModalCertidao.vue?vue&type=template&id=306c92ba&"
import script from "./ModalCertidao.vue?vue&type=script&lang=js&"
export * from "./ModalCertidao.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertidao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports